<template>
  <div class="overflow-y-scroll">
    <!--    <h3>{{ panelTitle }}</h3>-->
    <section>
      <div class="form-inline flex-row">
        <label>Consultant:</label>
        <div>
          <model-select
            :options="consultantOptions"
            v-model="editConsultant"
            placeholder="Consultant"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Rate:</label>
        <div class="rate-wrapper">
          <input type="text" placeholder="Rate" v-model="editRoleRate" />
          <model-select
            :options="rateTypeOptions"
            v-model="editRateType"
            placeholder="Rate Type"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Rate To Client:</label>
        <div class="rate-wrapper">
          <input
            type="text"
            placeholder="Rate To Client"
            v-model="editRoleRateToClient"
          />
          <model-select
            :options="rateTypeOptions"
            v-model="editRateTypeToClient"
            placeholder="Rate Type"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Status:</label>
        <div>
          <model-select
            :options="roleStatusOptions"
            v-model="editStatus"
            placeholder="Status"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Confirm:</label>
        <div>
          <model-select
            :options="confirmOptions"
            v-model="editConfirm"
            placeholder="Confirm"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Admin Confirm:</label>
        <div>
          <model-select
            :options="adminConfirmOptions"
            v-model="editAdminConfirm"
            placeholder="Admin Confirm"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Client Confirm:</label>
        <div>
          <model-select
            :options="clientConfirmOptions"
            v-model="editClientConfirm"
            placeholder="Client Confirm"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row m-t-l">
        <spinnerButton
          class="submit primary"
          :loading="loading"
          @click.native="buttonClick"
          >{{ panelButton }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import spinnerButton from "@/components/public/SpinnerButton";
import * as database from "@/vendor/database";
import { httpGet } from "@/http/http";

export default {
  props: [
    "roleData",
    "roleId",
    "consultantOptions",
    "selectedConsultants",
    "editId",
    "consultantId",
    "roleStatusOptions",
  ],
  components: {
    ModelSelect,
    spinnerButton,
  },
  data() {
    return {
      editType: null,
      panelTitle: null,
      panelButton: null,
      loading: false,
      editConsultant: null,
      editRoleId: null,
      editRoleRate: null,
      editRoleRateToClient: null,
      editConfirm: null,
      editAdminConfirm: null,
      editClientConfirm: null,
      editRateType: null,
      editRateTypeToClient: null,
      confirmOptions: [
        { text: "true", value: "yes" },
        { text: "false", value: "no" },
      ],
      adminConfirmOptions: [
        { text: "true", value: true },
        { text: "false", value: false },
      ],
      clientConfirmOptions: [
        { text: "true", value: true },
        { text: "false", value: false },
      ],
      rateTypeOptions: [
        { text: "hourly", value: "hourly" },
        { text: "monthly", value: "monthly" },
      ],
      editStatus: null,
      editorOption: {
        modules: {
          toolbar: [
            ["link", "bold", "italic", { list: "ordered" }, { list: "bullet" }],
          ],
        },
        theme: "snow",
      },
    };
  },
  created: function () {
    this.initData();
  },
  methods: {
    initData: function () {
      this.loading = false;
      this.editConsultant = null;
      this.editRoleId = this.roleId;
      if (this.consultantId) {
        this.panelTitle = "Edit Consultant";
        this.panelButton = "Edit Consultant";
        const c = this.selectedConsultants
          .find((item) => item.role_id === this.editRoleId)
          .consultants.find((item) => item.id === this.consultantId);
        this.editConsultant = this.consultantId;
        this.editRoleRate = c.role_rate;
        this.editRoleRateToClient = c.role_rate_to_client;
        this.editConfirm = c.reply;
        this.editAdminConfirm = c.confirm;
        this.editClientConfirm = c.client_confirm;
        this.editStatus = c.status;
        this.editRateType = c.c_rate_type;
        this.editRateTypeToClient = c.c_rate_type_to_client;
      } else {
        this.panelTitle = "Add Consultant";
        this.panelButton = "Add Consultant";
        this.editConsultant = null;
        this.editRoleRate = null;
        this.editRoleRateToClient = null;
        this.editConfirm = null;
        this.editAdminConfirm = null;
        this.editClientConfirm = null;
        this.editStatus = null;
        this.editRateType = null;
        this.editRateTypeToClient = null;
      }
    },
    buttonClick: async function () {
      let send_sms = true;
      if (this.editRoleId && this.editConsultant) {
        const consultantData = {
          id: this.editConsultant,
          role_rate: this.editRoleRate ? this.editRoleRate : null,
          role_rate_to_client: this.editRoleRateToClient
            ? this.editRoleRateToClient
            : null,
          reply: this.editConfirm ? this.editConfirm : null,
          confirm: this.editAdminConfirm ? this.editAdminConfirm : false,
          client_confirm: this.editClientConfirm
            ? this.editClientConfirm
            : false,
          status: this.editStatus ? this.editStatus : "Added",
          c_rate_type: this.editRateType ? this.editRateType : null,
          c_rate_type_to_client: this.editRateTypeToClient
            ? this.editRateTypeToClient
            : null,
        };
        let selectedConsultants = [];
        if (this.selectedConsultants && this.selectedConsultants.length > 0) {
          selectedConsultants = JSON.parse(
            JSON.stringify(this.selectedConsultants)
          );
        }
        const roleData = selectedConsultants.find(
          (item) => item.role_id === this.editRoleId
        );
        if (roleData) {
          if (roleData.consultants) {
            const editData = roleData.consultants.find(
              (item) => item.id === this.editConsultant
            );
            if (editData) {
              send_sms = false;
              editData.role_rate = consultantData.role_rate;
              editData.role_rate_to_client = consultantData.role_rate_to_client;
              editData.reply = consultantData.reply;
              editData.confirm = consultantData.confirm;
              editData.client_confirm = consultantData.client_confirm;
              editData.status = consultantData.status;
              editData.c_rate_type = consultantData.c_rate_type;
              editData.c_rate_type_to_client =
                consultantData.c_rate_type_to_client;
            } else {
              roleData.consultants.push(consultantData);
            }
          } else {
            roleData.consultants = [consultantData];
          }
        } else {
          selectedConsultants.push({
            role_id: this.editRoleId,
            consultants: [consultantData],
          });
        }

        try {
          this.loading = true;
          const result = await database.updateDocById("gigs", this.editId, {
            selected_consultants: selectedConsultants,
          });
          if (this.consultantId) {
            this.$toasted.global.toast_success({
              message: "edit success",
            });
            this.$emit("closePanel");
          } else {
            if (result.ok) {
              // const roleFind = this.roleData.find(
              //   (item) => item.id === this.roleId
              // );
              // if (roleFind && roleFind.autosend) {
              if (send_sms) {
                const smsResult = await httpGet(
                  "send_consultant_project_message",
                  {
                    projectId: this.editId,
                    roleId: this.roleId,
                    consultantId: this.editConsultant,
                  }
                );
                if (smsResult.ok) {
                  this.$toasted.global.toast_success({
                    message: "sms success",
                  });
                  this.$emit("closePanel");
                } else {
                  this.$toasted.global.toast_error({
                    message: smsResult.message,
                  });
                }
              } else {
                this.$emit("closePanel");
              }
              // } else {
              //   this.$emit("closePanel");
              // }
            } else {
              this.$toasted.global.toast_error({ message: "add error" });
            }
          }
          this.loading = false;
        } catch {
          this.$toasted.global.toast_error({ message: "add error" });
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.rate-wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}
.rate-wrapper > * {
  flex: 1 1 50%;
}
</style>
